define(['moduler'], function (Moduler) {
	'use strict';

	return Moduler.create({
		defaults: {
			container: '.js-textReferences',
			template: '<div class="Status Status--full Status--referenceOverlay js-referenceOverlay">' +
				'  <div class="Status-content">' +
				'    <a href="#" class="Status-closeLink js-close icon-close"></a>' +
				'  </div>' +
				'</div>',
			offsetBottom: '.Status--fixedBottom' // use a selector to offset the reference from the bottom by the height of the elements
		},

		init: function () {
			var self = this;

			self.el.addEventListener('click', function (e) {
				e.data = self;
				self.onShown(e);
			});
			self.container = document.querySelector(self.options.container);

			var intersectionObserver = new IntersectionObserver(entries => {
				entries.forEach((entry) => {
					if (self.isShown && entry.intersectionRatio > 0) {
						self.closeAll({ data: self });
					}
				});
			});

			intersectionObserver.observe(self.container);
		},

		onShown: function (e) {
			var self = e.data;
			e.preventDefault();
			e.stopPropagation();

			var referenceNumber = e.target.getAttribute('data-reference-number');

			// close all existing overlays
			self.closeAll({ data: self });

			// add active outline to current link
			e.target.classList.add('u-linkOutline');

			// setup overlay element
			var parser = new DOMParser();
			var overlayDoc = parser.parseFromString(self.options.template, "text/html");
			var overlay = overlayDoc.body.firstChild;

			overlay.setAttribute('data-number', referenceNumber);
			var overlayContent = overlay.querySelector('.Status-content') || overlay;
			overlayContent.insertAdjacentHTML('afterbegin', document.querySelector('[data-reference="' + referenceNumber + '"]').innerHTML);
			var closeButton = overlayContent.querySelector('.js-close');
			if (closeButton) {
				closeButton.addEventListener('click', function (e) {
					e.data = self;
					e.customTarget = overlay;
					self.onClose(e);
				});
				overlay.addEventListener('close', function () {
					self.onClose({
						customTarget: overlay,
						data: self,
						preventDefault: function () { },
						stopPropagation: function () { }
					});
				});
			}

			if (self.options.offsetBottom?.length > 0) {
				let offsetBottom = 0;
				document.querySelectorAll(self.options.offsetBottom).forEach(o => {
					offsetBottom += o.getBoundingClientRect().height;
				});
				overlay.style.bottom = offsetBottom + 'px';
			}

			// append overlay to container
			self.container.append(overlay);

			// wait a bit so that transitions work
			setTimeout(function () {
				overlay.classList.add('is-shown');
			}, 50);

			//self.$overlay = $overlay;
			self.isShown = true;
		},

		onClose: function (e) {
			var self = e.data;
			var target = e.customTarget || e.target;
			e.preventDefault();
			e.stopPropagation();

			// slide down overlay
			target.classList.remove('is-shown');

			// remove outline from current active link
			document.querySelectorAll('a[data-reference-number="' + target.getAttribute('data-number') + '"]').forEach(ref => ref.classList.remove('u-linkOutline'));

			// wait until animation is complete
			setTimeout(function () {
				if (target.parentNode) {
					target.parentNode.removeChild(target);
				}
			}, 500);

			self.isShown = false;
		},

		closeAll: function (e) {
			var self = e.data;
			var overlays = self.container.querySelectorAll('.js-referenceOverlay');
			overlays.forEach(overlay => {
				self.onClose({
					customTarget: overlay,
					data: self,
					preventDefault: function () { },
					stopPropagation: function () { }
				});
			});
		}
	});
});